<div class="modal-admin">
  <div class="header">
    <p class="close" (click)="cancel()"><img src="./assets/logos/close.svg" alt=""></p>
    <p class="title">{{data.title}}</p>
  </div>
  <div class="body">
    <form [formGroup]="form">

      <div class="input-control-error">
        <label for="reportType">{{data.formFields.reportType.text}}</label>
        <input type="text" id="reportType"
          [ngClass]="{'error-input': formSubmitted && form.controls.reportType.invalid}" formControlName="reportType"
          class="input-search" name="reportType" placeholder="" required>
        <div class="div-error" *ngIf="formSubmitted && form.controls.reportType.invalid">
          Campo obligatorio
        </div>
      </div>

      <div class="input-control-error">
        <label for="ob_Channel">{{data.formFields.ob_Channel.text}}</label>
        <input type="text" id="ob_Channel"
          [ngClass]="{'error-input': formSubmitted && form.controls.ob_Channel.invalid}" formControlName="ob_Channel"
          class="input-search" name="ob_Channel" placeholder="" required>
        <div class="div-error" *ngIf="formSubmitted && form.controls.ob_Channel.invalid">
          Campo obligatorio
        </div>
      </div>

      <div class="input-control-error">
        <label for="periodicity">{{data.formFields.periodicity.text}}</label>
        <select class="input-search" [ngClass]="{'error-input': formSubmitted && form.controls.periodicity.invalid}"
          formControlName="periodicity" name="periodicity" id="periodicity" style="width: 98%; height: 51px;">
          <option *ngFor="let option of data.formFields.periodicity.values" [value]="option.value">{{option.text}}
          </option>
        </select>
        <div class="div-error" *ngIf="formSubmitted && form.controls.periodicity.invalid">
          Campo obligatorio
        </div>
      </div>
    </form>


    <div class="input-control-error new-recipient">
      <label for="new_recipient">Agregar nuevo destinatario</label>
      <input type="text" id="new_recipient" [ngClass]="{'error-input': formSubmitted && !emails.length}" class="input-search"
        name="new_recipient" placeholder="" [(ngModel)]="emailModel">
      <div class="submit-button">
        <button id="addRecipient" (click)="addNewEmaill()">Agregar</button>
      </div>
      <div class="div-error" *ngIf="formSubmitted && !emails.length">
        Añade al menos un destinatario
      </div>
    </div>


    <div class="email-item" *ngFor="let email of emails; let i = index">
      {{email}}
      <img id="deleteRecipient" (click)="deleteEmail(i)" class="admin-icon" width="25px" style="cursor: pointer;float: right;" src="./assets/admin-icons/trash.PNG"
        alt="Borrar" title="Borrar">
    </div>
    <div class="submit-button bottom">
      <button id="submitCreateReport" (click)="submitForm()">{{data.buttonText}}</button>
    </div>

  </div>